import { TextField as BaseTextField } from '@kvdbil/components';
import { TextFieldProps as BaseTextFieldProps } from '@kvdbil/components/types/components/Textfield';
import { forwardRef, RefObject } from 'react';
import {
  Control,
  Controller,
  ControllerProps,
  FieldValues,
  Path,
  PathValue,
} from 'react-hook-form';

type ControllerBaseValue = string | number | readonly string[] | undefined;

export interface TextFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> extends BaseTextFieldProps {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  defaultValue?: PathValue<TFieldValues, Path<TFieldValues>>;
  rules?: ControllerProps<TFieldValues>['rules'];
}

const Input = forwardRef((props: BaseTextFieldProps, ref) => (
  <BaseTextField {...props} forwardRef={ref as RefObject<HTMLInputElement>} />
));

const TextFieldWithControl = <T extends FieldValues>(
  props: TextFieldProps<T>
) => {
  return (
    <Controller
      {...props}
      control={props.control}
      render={({ field, fieldState }) => {
        return (
          <Input
            {...props}
            {...field}
            value={(field.value as ControllerBaseValue) ?? ''}
            errors={props.errors ?? fieldState.error?.message?.split(',')}
            hasError={Boolean(fieldState.error)}
          />
        );
      }}
    />
  );
};

export default TextFieldWithControl;
